import React from "react";
import { Button, Menu } from "@mui/material";

type Props = {
  buttonIcon: React.ReactNode;
  buttonLabel: string;
  menuId: string;
  renderMenuItems: (closeMenu: () => void) => React.ReactNode;
};

export const MobileListMenu = ({ buttonIcon, buttonLabel, menuId, renderMenuItems }: Props) => {
  const [menuAnchorElement, setMenuAnchorElement] = React.useState<HTMLElement | null>(null);
  const isMenuOpen = Boolean(menuAnchorElement);

  const closeMenu = () => setMenuAnchorElement(null);

  return (
    <>
      <Button
        aria-controls={isMenuOpen ? menuId : undefined}
        aria-expanded={isMenuOpen ? "true" : undefined}
        aria-haspopup="menu"
        color="primary"
        onClick={(event) => setMenuAnchorElement(event.currentTarget)}
        size="small"
        startIcon={buttonIcon}
        variant="text"
      >
        {buttonLabel}
      </Button>
      <Menu anchorEl={menuAnchorElement} id={menuId} onClose={closeMenu} open={isMenuOpen}>
        {renderMenuItems(closeMenu)}
      </Menu>
    </>
  );
};
